import NewNote from '../component/NewNote'

function NewNoteScreen() {
    return (
        <div>
            <NewNote />
        </div>
    )
}

export default NewNoteScreen
